import {useEffect, useState} from 'react';
import useMuiMediaQuery, {
	type UseMediaQueryOptions,
} from '@mui/material/useMediaQuery';
import {type Theme} from '@netx/core-components/Theme';

// The beauty of browsers not being on the same damn spec
const inFullScreen = () => {
	return (
		(document.fullscreenElement ||
			(document as any).webkitFullscreenElement ||
			(document as any).mozFullScreenElement) != null
	);
};

/**
 * Wrapper for MUI useMediaQuery
 * When entering fullscreen mode the browser resizes, if you have components depending
 * on the screen size - it can get kind of gross
 * This makes sure that mediaQuery result is not updated while entering/being in fullscreen
 */
export const useMediaQuery = <T = Theme>(
	query: string | ((theme: T) => string),
	options?: UseMediaQueryOptions,
) => {
	const _mediaQuery = useMuiMediaQuery<T>(query, options);
	const [mediaQuery, setMediaQuery] = useState(_mediaQuery);

	useEffect(() => {
		if (inFullScreen()) return;
		setMediaQuery(_mediaQuery);
	}, [_mediaQuery]);

	return mediaQuery;
};

export default useMediaQuery;
